import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import Button from "../../../../Elements/Button/Button.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";

const DeleteBankModal = ({
  type,
  banksAccount,
  setBanksAccount,
  paypalAccounts,
  setPaypalAccounts,
  index,
}) => {
  const { closeModal } = useModal();
  const { getTextByKey } = useContent();
  const handleSubmit = () => {
    let body = {
      entryId: Number(index),
      delete: true,
    };
    removeBank(body);
  };

  const removeBank = async (body) => {
    const response = await apiRequest(
      "Users",
      `${
        type === "paypal"
          ? "SetPaypalAccountDetailsReact"
          : "SetBankAccountDetailsReact"
      }`,
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        removeBankFrontend();
      }
    }
  };

  const removeBankFrontend = () => {
    if (type === "paypal") {
      let newPaypalAccounts = [...paypalAccounts];
      newPaypalAccounts = newPaypalAccounts.filter(
        (item) => Number(item.keyIndex) !== Number(index)
      );
      setPaypalAccounts(newPaypalAccounts);
    } else {
      let newBanksAccount = [...banksAccount];
      newBanksAccount = newBanksAccount.filter(
        (item) => Number(item.keyIndex) !== Number(index)
      );
      setBanksAccount(newBanksAccount);
    }
    closeModal();
  };

  return (
    <div className="delete-bank-modal">
      <div className="delete-bank-header">
        <h3>{getTextByKey(`delete-bank-${type}`)}</h3>
      </div>
      <div className="delete-bank-actions">
        <Button onClick={() => closeModal()} className="blank">
          {getTextByKey("cancel")}
        </Button>
        <Button onClick={() => handleSubmit()}>{getTextByKey("delete")}</Button>
      </div>
    </div>
  );
};

export default DeleteBankModal;
